import { countUpNumbers } from '../parts/count-up';

const blockClientResults = () => {
	countUpNumbers();
	window.addEventListener('scroll', countUpNumbers);
};

document.defaultView.addEventListener('load', blockClientResults, false);
